<template>
  <div>
    <!-- <MyHeader /> -->
    <div class="detail">
      <div class="content" v-html="HtmlData"></div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import HtmlData from "../../../../data/about-us/ceo.html";
import MyFooter from "../../../../components/MyFooter.vue";

export default {
  data() {
    return {
      HtmlData,
    };
  },
  components: {
    MyFooter,
  },
  head() {
    return {
      title: "姚军红个人简介",
    };
  },
};
</script>

<style lang="less" scoped>
.detail {
  max-width: 760px;
  margin: 0 auto;
  padding: 0 48px/2;
  margin-bottom: 120px;

  .content {
    margin-top: 48px;
  }
}

@media screen and (max-width: 540px) {
  .detail {
    margin-bottom: 50px;

    .content {
      & /deep/ p {
        // margin: 50px/2 0;
        line-height: 50px/2;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/ceo/index.vue